@for (card of cards; track card) {
  <sd-visual-card
    [isLoading]="isLoading"
    [card]="card.card"
    [brand]="brand ? brand : card.card?.brandCorner ? card.card.brandCorner : undefined"
    [titleLevel]="titleLevel"
    [layoutTextConfig]="layoutTextConfig"
    [visualCardSize]="visualCardsSize"
    [themesConfig]="card?.themesConfig"
    [isDescription]="isDescription"
    [invertTitle]="invertTitle"
    [hasModal]="card.hasModal"
    (videoPlayed)="onVideoPlayed($event)"
    (videoEnded)="onVideoEnded($event)"
    [twicPicsAutoSize]="twicPicsAutoSize"
  />
}
